import { render } from "./SearchCriteria.vue?vue&type=template&id=3304784e"
import script from "./SearchCriteria.vue?vue&type=script&lang=js"
export * from "./SearchCriteria.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__